import angular from 'angular';

FormsDirective.$inject = [];
function FormsDirective() {
  FormsController.$inject = ['$scope'];
  function FormsController($scope) {
    $scope.forms = {};
  }

  return {
    restrict: 'A',

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: FormsController,
  };
}

export const FormsDirectiveModule = angular
  .module('acme.common.directive.forms', [
    'acme.common.directive.forms.radio',
    'acme.common.directive.forms.radioGroup',
    'acme.common.directive.forms.checkbox',
    'acme.common.directive.forms.cardTypes',
  ])
  .directive('forms', FormsDirective).name;
